import type { IFilterSortOption } from '~/types/sort';

import IMAGE_FIRST_SESSION from '~/modules/page-analytic/assets/images/first-session.png';
import IMAGE_ALL_SESSION from '~/modules/page-analytic/assets/images/all-sessions.png';
import { createNumberSortOptions, createTextSortOptions } from '~/utils';
import { EAnalyticMode } from '~/modules/analytics/types';
import { EMetricKey } from '~/types/metric';
import { EPageField } from '~/core/gemxql';

export const VIEW_BY_OPTIONS = [
  {
    id: EAnalyticMode.ALL_SESSION,
    content: 'All sessions',
    helpText:
      'Count metrics for all sessions where this page shows up anywhere in the journey: before, during, or after other pages.',
    icon: IMAGE_ALL_SESSION,
  },
  {
    id: EAnalyticMode.FIRST_SESSION,
    content: 'Entry session only',
    helpText:
      'Count metrics for sessions only where this page was the very first page visited, then track how they moved through the funnel.',
    icon: IMAGE_FIRST_SESSION,
  },
  // {
  //   id: EAnalyticMode.PAGE_ONLY,
  //   content: 'Page only',
  //   helpText:
  //     'Count metrics from current page that lead directly to checkout, using data from all sessions that visited it.',
  //   icon: IMAGE_PAGE_ONLY,
  // },
];

export const PA_PAGE_TITLE_KEY = 'pageTitle';
export const PA_SORT_METRIC_PAGE_TITLE = createTextSortOptions('Page title', EPageField.PAGE_TITLE);
export const PA_SORT_METRIC_SESSIONS = createNumberSortOptions('Sessions', EMetricKey.SESSION);
export const PA_SORT_METRIC_BR = createNumberSortOptions('Bounce rate', EMetricKey.BOUNCE_RATE);
export const PA_SORT_METRIC_CTR = createNumberSortOptions('CTR', EMetricKey.CTR);
export const PA_SORT_METRIC_CR = createNumberSortOptions('CR', EMetricKey.CONVERSION_RATE);

export const DEFAULT_PAGE_ANALYTIC_SORT_OPTIONS: IFilterSortOption = [
  ...PA_SORT_METRIC_PAGE_TITLE,
  ...PA_SORT_METRIC_SESSIONS,
  ...PA_SORT_METRIC_BR,
  ...PA_SORT_METRIC_CTR,
  ...PA_SORT_METRIC_CR,
];

export const DEFAULT_MODAL_PAGE_ANALYTIC_SORT_OPTIONS: IFilterSortOption = [
  ...PA_SORT_METRIC_PAGE_TITLE,
];
